import "./Home.css"
import Slideshow from "./Slideshow/Slideshow";
import ServiceList from "./ServiceList/ServiceList";
import UpcomingWebinars from "./UpcomingWebinars/UpcomingWebinars";
import AboutV2 from "./About/AboutV2";
const Home = () => {
    return (
        <div className = 'section'>
            <Slideshow/>
            <UpcomingWebinars/>
            <AboutV2/>
            <ServiceList/>
        </div>
    )
}


export default Home;